export const ptPT = {
  common: {
    brand: "Devil's Paw",
    back: 'Voltar',
    cancel: 'Cancelar',
    close: 'Fechar',
    save: 'Guardar',
    loading: 'A invocar o Diabo…',
    characters: '{count}/{max}',
    seconds: { one: '{count} segundo', other: '{count} segundos' },
    player: 'jogador',
    players: 'jogadores',
    soul: 'Alma',
    souls: 'Almas',
    round: 'Ronda {current} de {total}',
    yes: 'Sim',
    no: 'Não',
  },
  nav: {
    home: 'Início',
    skipToContent: 'Saltar para o conteúdo principal',
    howToPlay: 'Como jogar',
    mute: 'Silenciar sons',
    unmute: 'Activar sons',
    language: 'Idioma',
    portuguese: 'Português',
    english: 'English',
    theme: 'Tema',
    themeSystem: 'Sistema',
    themeLight: 'Claro',
    themeDark: 'Escuro',
  },
  landing: {
    eyebrow: 'Um desejo inocente',
    tagline: 'Pede. Concede. Arrepende-te.',
    description: 'Um party game onde todos os desejos são concedidos da pior maneira possível.',
    createRoom: 'Criar sala',
    joinRoom: 'Entrar numa sala',
    howToPlay: 'Descobrir como jogar',
    exampleLabel: 'UM DESEJO INOCENTE',
    exampleWish: 'QUERO SER IMORTAL.',
    exampleCurse: 'vais sentir todas as dores para sempre.',
    exampleHint: 'Os teus amigos decidem se a maldição merece uma Alma.',
  },
  form: {
    nickname: 'A tua alcunha',
    nicknamePlaceholder: 'Alcunha',
    avatar: 'Escolhe a tua marca',
    roomCode: 'Código da sala',
    roomCodePlaceholder: 'ABCDE',
    required: 'Preenche este campo.',
  },
  create: {
    title: 'ABRE O CÍRCULO',
    subtitle: 'Cria uma sala e convida os teus cúmplices.',
    submit: 'Criar sala',
    pending: 'A abrir a sala…',
  },
  join: {
    title: 'ENTRA NO PACTO',
    subtitle: 'Tens um código? O Diabo trata do resto.',
    submit: 'Entrar na sala',
    pending: 'À procura da sala…',
    check: 'Continuar',
    roomGone: 'Essa sala já não existe. Confirma o código ou pede um novo convite.',
    invalidCode: 'O código deve ter cinco letras.',
    spectatorTitle: 'ASSISTE AO PACTO',
    joinAsSpectator: 'Entrar como espectador',
    joinAsPlayer: 'Entrar como jogador',
  },
  connection: {
    connected: 'Ligado ao círculo.',
    connecting: 'A ligar ao servidor…',
    reconnecting: 'A tentar recuperar a ligação…',
    offline: 'Sem ligação. O modo multijogador não funciona offline.',
    serverShutdown: 'O servidor vai reiniciar. Volta a ligar-te dentro de instantes.',
    phaseMoved: 'Enquanto estiveste ausente, o jogo avançou. Já estás na fase actual.',
  },
  offline: {
    eyebrow: 'O círculo foi interrompido',
    title: 'PRECISAS DE LIGAÇÃO.',
    description: 'Devil\'s Paw é um jogo multijogador em tempo real. Não existe uma sala offline nem mostramos uma sala antiga como se ainda estivesse activa.',
    retry: 'Volta a ligar-te à Internet. O jogo tenta recuperar a sessão automaticamente.',
  },
  native: {
    leaveRoundConfirm: 'A ronda ainda está a decorrer. Queres mesmo sair do jogo?',
  },
  error: {
    title: 'O pacto falhou',
    generic: 'Não foi possível concluir a acção. Tenta novamente.',
    network: 'Não foi possível contactar o servidor.',
    roomNotFound: 'A sala já não existe.',
    roomFull: 'A sala está cheia.',
    gameStarted: 'A partida já começou.',
    invalidReconnect: 'A sessão guardada expirou. Volta a entrar na sala.',
    stalePhase: 'O jogo já avançou para a fase seguinte.',
    rateLimited: 'Demasiadas acções seguidas. Espera um instante.',
    forbidden: 'Não tens permissão para fazer isso.',
    pairingExpired: 'O código de emparelhamento expirou. Gera um novo no televisor.',
    pairingUsed: 'Esse código de emparelhamento já foi utilizado.',
    pairingInvalid: 'Não foi possível ligar este telemóvel ao lugar no televisor.',
    demoSpeedProduction: 'A aceleração da demonstração está desactivada em produção.',
  },
  lobby: {
    title: 'TODOS PARA O CÍRCULO.',
    subtitle: 'Lê o QR code ou entra em grantedbut.bentolento.com',
    code: 'Código {code}',
    joinLink: 'Link de convite',
    copyLink: 'Copiar link',
    copied: 'Link copiado.',
    qrAlt: 'Código QR para entrar na sala {code}',
    playersTitle: 'Cúmplices',
    online: 'online',
    offline: 'offline',
    ready: 'pronto',
    notReady: 'a preparar-se',
    host: 'anfitrião',
    bot: 'Diabo Bot',
    empty: 'Ainda não há ninguém no círculo.',
    nudge: 'A maldição fica melhor com 4 ou mais jogadores.',
    fillBots: 'Completar com Diabo Bots',
    addBot: 'Adicionar bot',
    removeBot: 'Remover bot',
    readyUp: 'Estou pronto',
    unready: 'Ainda não estou pronto',
    controls: 'Controlos do anfitrião',
    settings: 'Definições da partida',
    roomName: 'Nome da sala',
    rounds: 'Rondas',
    wishSeconds: 'Tempo para desejar',
    consequenceSeconds: 'Tempo para amaldiçoar',
    voteSeconds: 'Tempo para votar',
    revealSeconds: 'Tempo de revelação',
    hellMode: 'Modo Inferno (sem janela de leitura)',
    familyFilter: 'Filtro familiar',
    autoReveal: 'Revelação automática',
    start: 'Começar partida',
    startNeedPlayers: 'São necessários pelo menos 4 jogadores para começar.',
    startNeedReady: 'Todos os jogadores humanos têm de estar prontos antes de começar.',
    startHostNotReady: 'Marca-te como pronto para começar a partida.',
    kick: 'Expulsar',
    transferHost: 'Transferir anfitrião',
    waitingHost: 'O anfitrião começa quando o círculo estiver pronto.',
    roundSummary: { one: '{count} ronda', other: '{count} rondas' },
    timeSummary: '{count} seg por maldição',
    botSummary: { one: '{count} Diabo Bot', other: '{count} Diabo Bots' },
    spectatorSummary: { one: '{count} espectador', other: '{count} espectadores' },
    hostTransferred: '{name} é agora o anfitrião.',
  },
  pairing: {
    controller: 'Controlador móvel',
    title: 'ESCREVER NO TELEMÓVEL',
    writeOnPhone: 'Escrever no telemóvel',
    pending: 'A criar ligação segura…',
    instructions: 'Lê este QR code no telemóvel. Só funciona uma vez e expira rapidamente.',
    qrAlt: 'QR code para controlar o participante já sentado na sala {code}',
    connecting: 'A ligar ao teu lugar…',
    joinNormally: 'Entrar como outro jogador',
    phoneHasInput: 'O TELEMÓVEL TEM A PALAVRA.',
    tvWaiting: 'O texto privado está no controlador emparelhado.',
    returnToTv: 'Voltar a escrever no televisor',
  },
  hostControls: {
    title: 'Controlos do anfitrião',
    toggle: 'Abrir controlos do anfitrião',
    pause: 'Pausar',
    resume: 'Retomar',
    addTime: '+15 segundos',
    transfer: 'Transferir',
  },
  demo: {
    starting: 'A preparar uma partida automática real…',
  },
  countdown: {
    round: 'RONDA {round}',
    title: 'PREPARA O PRÓXIMO PACTO.',
    subtitle: 'Todos começam ao mesmo tempo.',
  },
  wish: {
    title: 'O DIABO ESTÁ A OUVIR.',
    subtitle: 'Escreve algo que desejarias mesmo. Os outros tratarão do resto.',
    placeholder: 'Quero…',
    listening: 'O Diabo está a ouvir.',
    fieldLabel: 'O TEU DESEJO',
    submit: 'SELAR DESEJO',
    submitted: 'Desejo selado.',
    waiting: 'À espera dos restantes desejos…',
    autoSubmit: 'O teu desejo foi selado quando o tempo terminou.',
  },
  consequence: {
    title: 'ARRUÍNA-O COM CLASSE.',
    subtitle: 'O desejo tem de ser concedido. A crueldade é criativa, não burocrática.',
    progress: 'Maldição {current} de {total}',
    prefix: 'CONCEDIDO, MAS…',
    placeholder: 'há sempre um preço.',
    limitHint: '{count} caracteres · uma linha',
    submit: 'SELAR MALDIÇÃO',
    waiting: 'Os restantes ainda estão a negociar…',
    answered: { one: '{submitted} de {expected} jogador respondeu', other: '{submitted} de {expected} jogadores responderam' },
    noAssignment: 'Não tens um desejo para amaldiçoar nesta ronda.',
    submitted: 'Maldição selada.',
    wishLabel: 'DESEJO',
  },
  vote: {
    title: 'ESCOLHE A MELHOR MALDIÇÃO',
    wishLabel: 'DESEJO: “{wish}”',
    reading: 'Lê primeiro. A votação abre dentro de instantes.',
    open: 'A votação está aberta.',
    progress: 'Desejo {current} de {total}',
    ownCard: 'A tua maldição — não podes votar nela',
    select: 'Votar na carta {label}',
    chosen: 'Voto selado na carta {label}.',
    confirm: 'VOTAR EM {label}',
    instructions: 'Toca num cartão para o escolher.',
    waiting: 'Voto selado. À espera dos restantes jogadores…',
    abstain: 'Não votar é uma abstenção real.',
    noCards: 'Nenhuma maldição chegou a este desejo.',
  },
  reveal: {
    title: 'A VERDADE VEM AO DE CIMA',
    progress: 'REVELAÇÃO {current} DE {total}',
    wishBy: 'Desejo de {name}',
    curseBy: 'Maldição de {name}',
    votes: { one: '{count} voto', other: '{count} votos' },
    winner: 'MELHOR MALDIÇÃO',
    culprit: 'Quem te lixou?',
    soulStolen: 'Roubaste uma Alma.',
    soulBanner: '{name} ROUBOU UMA ALMA +1',
    noSoul: 'Nenhuma Alma foi roubada.',
    paused: 'Revelação em pausa',
    pause: 'Pausar revelação',
    resume: 'Retomar revelação',
    advance: 'Avançar revelação',
    autoOn: 'Revelação automática activa',
    autoOff: 'Revelação automática inactiva',
    tieBreak: 'O desempate premiou quem selou primeiro.',
    abstentions: { one: '{count} abstenção', other: '{count} abstenções' },
  },
  scoreboard: {
    title: 'QUEM VENDEU MELHOR A ALMA?',
    roundEnd: 'FIM DA RONDA {round}',
    roundScore: 'Nesta ronda',
    totalScore: 'Total',
    votes: 'Votos recebidos',
    votesCount: { one: '{count} voto recebido', other: '{count} votos recebidos' },
    winner: 'Vencedor: {names}',
    jointWinners: 'Vencedores empatados: {names}',
    nextRound: 'Jogar nova ronda',
    endGame: 'Terminar partida',
    shareBest: 'Partilhar melhor maldição',
    shared: 'Imagem copiada.',
    downloaded: 'Imagem descarregada.',
    noBest: 'Ainda não há uma maldição para partilhar.',
    shareTitle: 'A melhor maldição',
    shareFootnote: "Criado localmente por Devil's Paw — nada foi publicado.",
  },
  rules: {
    title: 'QUATRO PASSOS. ZERO MISERICÓRDIA.',
    intro: 'COMO JOGAR',
    stepWishTitle: '1. PEDE DEMAIS',
    stepWishBody: 'Escreve um desejo. Uma linha, sem condições.',
    stepCurseTitle: '2. CONCEDE-O',
    stepCurseBody: 'Todos os desejos são aceites.',
    stepVoteTitle: '3. ESTRAGA-O',
    stepVoteBody: 'Cria uma consequência que faça a pessoa arrepender-se.',
    stepRevealTitle: '4. VOTA ÀS ESCURAS',
    stepRevealBody: 'Escolhe a melhor maldição. Os autores só aparecem no fim.',
    tieBreak: 'Empate? O Diabo não espera. Ganha quem tiver selado a maldição primeiro.',
    privacy: 'Antes do reveal, ninguém — nem o anfitrião — vê quem escreveu cada maldição.',
  },
  display: {
    sessionNickname: 'Ecrã partilhado',
    open: 'Abrir ecrã partilhado',
    roomTitle: 'SALA DE JOGO',
    players: 'JOGADORES',
    joinNoInstall: 'ENTRA SEM INSTALAR NADA',
    wishTitle: 'A RECOLHER DESEJOS.',
    consequenceTitle: 'A RECOLHER MALDIÇÕES.',
    voteInstruction: 'Votem nos vossos dispositivos',
    tipTitle: 'DICA DO DIABO',
    tipBody: 'Respostas curtas vencem mais vezes. Crueldade cirúrgica, não tese de mestrado.',
    submissionProgress: { one: '{submitted} de {expected} jogador terminou', other: '{submitted} de {expected} jogadores terminaram' },
    voteProgress: { one: '{submitted} de {expected} jogador já votou', other: '{submitted} de {expected} jogadores já votaram' },
  },
  coming: {
    title: 'O PORTAL AINDA ESTÁ FECHADO',
    demo: 'O modo de demonstração automática chega no próximo slice.',
    returnHome: 'Voltar ao início',
  },
  audio: {
    seal: 'Som: selo estampado.',
    tick: 'Som: último segundo a passar.',
    flip: 'Som: carta virada.',
    win: 'Som: maldição vencedora.',
  },
  avatar: {
    demon: 'Demónio',
    flame: 'Chama',
    moon: 'Lua',
    eye: 'Olho',
    skull: 'Caveira',
    crystal: 'Cristal',
  },
} as const;

type LocaleShape<T> = {
  readonly [K in keyof T]: T[K] extends string ? string : LocaleShape<T[K]>;
};

export const en = {
  common: {
    brand: "Devil's Paw", back: 'Back', cancel: 'Cancel', close: 'Close', save: 'Save',
    loading: 'Summoning the Devil…', characters: '{count}/{max}', seconds: { one: '{count} second', other: '{count} seconds' },
    player: 'player', players: 'players', soul: 'Soul', souls: 'Souls', round: 'Round {current} of {total}',
    yes: 'Yes', no: 'No',
  },
  nav: {
    home: 'Home', skipToContent: 'Skip to main content', howToPlay: 'How to play', mute: 'Mute sounds', unmute: 'Enable sounds',
    language: 'Language', portuguese: 'Português', english: 'English', theme: 'Theme', themeSystem: 'System', themeLight: 'Light', themeDark: 'Dark',
  },
  landing: {
    eyebrow: 'A game of wishes granted terribly', tagline: 'Wish. Granted. Regret it.',
    description: 'Write a wish. Ruin your friends’ wishes. Vote for the best curse and steal Souls.',
    createRoom: 'Create room', joinRoom: 'Join a room', howToPlay: 'Learn how to play', exampleLabel: 'AN INNOCENT WISH',
    exampleWish: 'I WANT TO BE IMMORTAL.', exampleCurse: 'you will feel every pain forever.',
    exampleHint: 'Your friends decide whether the curse deserves a Soul.',
  },
  form: {
    nickname: 'Your nickname', nicknamePlaceholder: 'Nickname', avatar: 'Choose your mark',
    roomCode: 'Room code', roomCodePlaceholder: 'ABCDE', required: 'Fill in this field.',
  },
  create: { title: 'OPEN THE CIRCLE', subtitle: 'Create a room and invite your accomplices.', submit: 'Create room', pending: 'Opening the room…' },
  join: {
    title: 'ENTER THE PACT', subtitle: 'Got a code? The Devil handles the rest.', submit: 'Join room',
    pending: 'Looking for the room…', check: 'Continue', roomGone: 'That room no longer exists. Check the code or ask for a new invite.',
    invalidCode: 'The code must have five letters.',
    spectatorTitle: 'WATCH THE PACT', joinAsSpectator: 'Join as spectator', joinAsPlayer: 'Join as player',
  },
  connection: {
    connected: 'Connected to the circle.', connecting: 'Connecting to the server…',
    reconnecting: 'Trying to recover the connection…', offline: 'Offline. Multiplayer does not work offline.',
    serverShutdown: 'The server is restarting. Reconnect in a moment.',
    phaseMoved: 'The game moved on while you were away. You are now in the current phase.',
  },
  offline: {
    eyebrow: 'The circle was broken', title: 'YOU NEED A CONNECTION.',
    description: "Devil's Paw is a real-time multiplayer game. There is no offline room, and we never show an old room as if it were still live.",
    retry: 'Reconnect to the Internet. The game will try to recover your session automatically.',
  },
  native: { leaveRoundConfirm: 'The round is still live. Do you really want to leave the game?' },
  error: {
    title: 'The pact failed', generic: 'The action could not be completed. Try again.', network: 'The server could not be reached.',
    roomNotFound: 'The room no longer exists.', roomFull: 'The room is full.', gameStarted: 'The game has already started.',
    invalidReconnect: 'The saved session expired. Join the room again.', stalePhase: 'The game already moved to the next phase.',
    rateLimited: 'Too many actions. Wait a moment.', forbidden: 'You do not have permission to do that.',
    pairingExpired: 'The pairing code expired. Generate a new one on the TV.', pairingUsed: 'That pairing code has already been used.',
    pairingInvalid: 'This phone could not be attached to the seat on the TV.', demoSpeedProduction: 'Demo acceleration is disabled in production.',
  },
  lobby: {
    title: 'EVERYONE TO THE CIRCLE.', subtitle: 'Scan the QR code or visit grantedbut.bentolento.com', code: 'Code {code}', joinLink: 'Invite link', copyLink: 'Copy link', copied: 'Link copied.',
    qrAlt: 'QR code to join room {code}', playersTitle: 'Accomplices', online: 'online', offline: 'offline', ready: 'ready',
    notReady: 'getting ready', host: 'host', bot: 'Devil Bot', empty: 'Nobody is in the circle yet.',
    nudge: 'The curse is better with 4 or more players.', fillBots: 'Fill with Devil Bots', addBot: 'Add bot', removeBot: 'Remove bot',
    readyUp: 'I am ready', unready: 'I am not ready', controls: 'Host controls', settings: 'Game settings', roomName: 'Room name',
    rounds: 'Rounds', wishSeconds: 'Wish time', consequenceSeconds: 'Curse time', voteSeconds: 'Voting time',
    revealSeconds: 'Reveal time', hellMode: 'Hell Mode (no reading window)', familyFilter: 'Family filter',
    autoReveal: 'Automatic reveal', start: 'Start game', startNeedPlayers: 'At least 4 players are required to start.',
    startNeedReady: 'All human players must be ready before starting.', startHostNotReady: 'Mark yourself ready to start the game.', kick: 'Kick', transferHost: 'Transfer host',
    waitingHost: 'The host starts when the circle is ready.',
    roundSummary: { one: '{count} round', other: '{count} rounds' }, timeSummary: '{count} sec per curse',
    botSummary: { one: '{count} Devil Bot', other: '{count} Devil Bots' }, spectatorSummary: { one: '{count} spectator', other: '{count} spectators' },
    hostTransferred: '{name} is now the host.',
  },
  pairing: {
    controller: 'Mobile controller', title: 'WRITE ON YOUR PHONE', writeOnPhone: 'Write on your phone', pending: 'Creating a secure link…',
    instructions: 'Scan this QR code on your phone. It works once and expires quickly.', qrAlt: 'QR code to control the participant already seated in room {code}',
    connecting: 'Connecting to your seat…', joinNormally: 'Join as another player', phoneHasInput: 'THE PHONE HAS THE FLOOR.',
    tvWaiting: 'Private text is on the paired controller.', returnToTv: 'Write on the TV again',
  },
  hostControls: { title: 'Host controls', toggle: 'Open host controls', pause: 'Pause', resume: 'Resume', addTime: '+15 seconds', transfer: 'Transfer' },
  demo: { starting: 'Preparing a real automated match…' },
  countdown: { round: 'ROUND {round}', title: 'PREPARE THE NEXT PACT.', subtitle: 'Everyone starts together.' },
  wish: {
    title: 'THE DEVIL IS LISTENING.', subtitle: 'Write something you truly wish for. The others will handle the rest.', placeholder: 'I wish…',
    listening: 'The Devil is listening.', fieldLabel: 'YOUR WISH', submit: 'SEAL WISH', submitted: 'Wish sealed.', waiting: 'Waiting for the other wishes…',
    autoSubmit: 'Your wish was sealed when time ran out.',
  },
  consequence: {
    title: 'RUIN IT WITH CLASS.', subtitle: 'The wish must be granted. Cruelty is creative, not bureaucratic.', progress: 'Curse {current} of {total}', prefix: 'GRANTED, BUT…', placeholder: 'there is always a price.', limitHint: '{count} characters · one line',
    submit: 'SEAL CURSE', waiting: 'The others are still negotiating…', answered: { one: '{submitted} of {expected} player answered', other: '{submitted} of {expected} players answered' },
    noAssignment: 'You have no wish to curse this round.', submitted: 'Curse sealed.', wishLabel: 'WISH',
  },
  vote: {
    title: 'CHOOSE THE BEST CURSE', wishLabel: 'WISH: “{wish}”', reading: 'Read first. Voting opens shortly.', open: 'Voting is open.',
    progress: 'Wish {current} of {total}', ownCard: 'Your curse — you cannot vote for it', select: 'Vote for card {label}',
    chosen: 'Vote sealed on card {label}.', waiting: 'Vote sealed. Waiting for the other players…',
    confirm: 'VOTE FOR {label}', instructions: 'Tap a card to select it.',
    abstain: 'Not voting is a real abstention.', noCards: 'No curses reached this wish.',
  },
  reveal: {
    title: 'THE TRUTH COMES OUT', progress: 'REVEAL {current} OF {total}', wishBy: 'Wish by {name}', curseBy: 'Curse by {name}', votes: { one: '{count} vote', other: '{count} votes' },
    winner: 'BEST CURSE', culprit: 'Who screwed you over?', soulStolen: 'You stole a Soul.', soulBanner: '{name} STOLE A SOUL +1', noSoul: 'No Soul was stolen.',
    paused: 'Reveal paused', pause: 'Pause reveal', resume: 'Resume reveal', advance: 'Advance reveal',
    autoOn: 'Automatic reveal enabled', autoOff: 'Automatic reveal disabled', tieBreak: 'The tie-break rewarded the first curse sealed.',
    abstentions: { one: '{count} abstention', other: '{count} abstentions' },
  },
  scoreboard: {
    title: 'WHO SOLD THEIR SOUL BEST?', roundEnd: 'END OF ROUND {round}', roundScore: 'This round', totalScore: 'Total', votes: 'Votes received', votesCount: { one: '{count} vote received', other: '{count} votes received' }, winner: 'Winner: {names}',
    jointWinners: 'Joint winners: {names}', nextRound: 'Play another round', endGame: 'End game', shareBest: 'Share best curse',
    shared: 'Image copied.', downloaded: 'Image downloaded.', noBest: 'There is no curse to share yet.', shareTitle: 'The best curse',
    shareFootnote: "Created locally by Devil's Paw — nothing was published.",
  },
  rules: {
    title: 'FOUR STEPS. ZERO MERCY.', intro: 'HOW TO PLAY',
    stepWishTitle: '1. ASK TOO MUCH', stepWishBody: 'Write one wish. One line, no conditions.',
    stepCurseTitle: '2. GRANT IT', stepCurseBody: 'Every wish is accepted.',
    stepVoteTitle: '3. RUIN IT', stepVoteBody: 'Create a consequence that makes them regret it.',
    stepRevealTitle: '4. VOTE IN THE DARK', stepRevealBody: 'Choose the best curse. Authors only appear at the end.',
    tieBreak: 'Tie? The Devil does not wait. Whoever sealed the curse first wins.',
    privacy: 'Before the reveal, nobody — not even the host — sees who wrote each curse.',
  },
  display: {
    sessionNickname: 'Shared display',
    open: 'Open shared display',
    roomTitle: 'GAME ROOM',
    players: 'PLAYERS',
    joinNoInstall: 'JOIN WITHOUT INSTALLING',
    wishTitle: 'COLLECTING WISHES.',
    consequenceTitle: 'COLLECTING CURSES.',
    voteInstruction: 'Vote on your devices',
    tipTitle: "THE DEVIL'S TIP",
    tipBody: 'Short answers win more often. Surgical cruelty, not a thesis.',
    submissionProgress: { one: '{submitted} of {expected} player finished', other: '{submitted} of {expected} players finished' },
    voteProgress: { one: '{submitted} of {expected} player has voted', other: '{submitted} of {expected} players have voted' },
  },
  coming: {
    title: 'THE PORTAL IS STILL CLOSED',
    demo: 'Automatic demo mode arrives in the next slice.', returnHome: 'Return home',
  },
  audio: { seal: 'Sound: seal stamped.', tick: 'Sound: final second passing.', flip: 'Sound: card flipped.', win: 'Sound: winning curse.' },
  avatar: { demon: 'Demon', flame: 'Flame', moon: 'Moon', eye: 'Eye', skull: 'Skull', crystal: 'Crystal' },
} as const satisfies LocaleShape<typeof ptPT>;

export const translations = { 'pt-PT': ptPT, en } as const;
export type Locale = keyof typeof translations;
